var map = {
  "./cs.json": [
    "xlB",
    [
      "fnp"
    ]
  ],
  "./en.json": [
    "uY",
    [
      "4mq"
    ]
  ],
  "./pl.json": [
    "ej",
    [
      "wg"
    ]
  ],
  "./ru.json": [
    "C89",
    [
      44
    ]
  ],
  "./tr.json": [
    "Fu",
    [
      "vs"
    ]
  ],
  "./ja.json": [
    "QL",
    [
      "ifd"
    ]
  ],
  "./zh.json": [
    "mI",
    [
      "cu5"
    ]
  ],
  "./pt-br.json": [
    "DZt",
    [
      10
    ]
  ],
  "./de.json": [
    "wH",
    [
      "er"
    ]
  ],
  "./es.json": [
    "zU",
    [
      "d1b"
    ]
  ],
  "./fr.json": [
    "l1q",
    [
      "rd"
    ]
  ],
  "./it.json": [
    "COD",
    [
      "8b"
    ]
  ],
  "./ko.json": [
    "ho",
    [
      "bb"
    ]
  ],
  "./pt.json": [
    "Opt",
    [
      "sk"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "Eh";
module.exports = __rspack_async_context;
